export const senderMail = {
    host: "mail.dscontsoftware.com",
    port: 465,
    user: 'noresponder@dscontsoftware.com',
    pass: 'N0R3sp0nd3r@20*20',
    from: 'noresponder@dscontsoftware.com'
}